import React from "react";

export default function PageHero({ title, subtitle, description, image }) {
  return (
    <section
      className="relative min-h-[60vh] flex items-center justify-center text-white"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-ocean-900/70 via-indigo-900/60 to-ocean-900/80" />
      <div className="relative z-10 text-center px-4 max-w-3xl mx-auto pt-24 pb-16 animate-fadeUp">
        <p className="section-subtitle text-ocean-300 mb-3">{subtitle}</p>
        <h1 className="font-serif text-4xl md:text-6xl font-bold leading-tight mb-4">
          {title}
        </h1>
        <p className="text-white/80 text-lg max-w-xl mx-auto">{description}</p>
      </div>
      {/* Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 80" className="w-full" preserveAspectRatio="none" style={{height: 60}}>
          <path fill="white" d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" />
        </svg>
      </div>
    </section>
  );
}
